import { INITIAL_MACHINERIES_REQUEST, FETCH_MACHINERIES_SUCCESS } from "../../types/maintainers/machineries.type";

const initialState = {
	estates: [],
	customers: [],
	machineries: [],
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
};

function maintainers_machineries(state = initialState, action) {
	switch (action.type) {
		case INITIAL_MACHINERIES_REQUEST:
			return {
				...state,
				isFetching: true,
			};

		case FETCH_MACHINERIES_SUCCESS:
			return {
				...state,
				isFetching: false,
				customers: action.payload.customers,
				estates: action.payload.estates,
				machineries: action.payload.machineries,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
				quantity: action.payload.quantity,
			};
		default:
			return state;
	}
}

export default maintainers_machineries;
